import React from 'react';
import { List, Button, Icon } from 'antd';
import moment from 'moment';
import OptimisationErrorWarningList from '../../containers/OptimisationErrorWarningList';
import {
  ProgressListWrapper, ProgressList, TrianglePointer, TimeStamp, Footer,
} from './styles';


const OptimiseProgress = ({
  optimise: {
    messages, hasErrors, hasWarnings, id,
  }, onClickOpenRelocatableDrawer,
  isOptimiseRunning,
}) => (
  <ProgressListWrapper>
    <ProgressList
      size="small"
      maxHeight="60vh"
      loading={!messages}
      dataSource={messages}
      renderItem={({ body, createdAt }, i) => (
        // TODO: <span /> is for a quick styling fix, ideally this should be changed.
        <List.Item
          extra={(i === (messages.length - 1)) ? <TrianglePointer /> : <span />}
        >
          <List.Item.Meta
            title={body.message}
          />
          <TimeStamp color="greyscale.2" pt="12px">
            {moment(createdAt).format('LT')}
          </TimeStamp>
        </List.Item>
      )}
    />
    <Footer>
      <Button
        size="small"
        onClick={() => onClickOpenRelocatableDrawer(<OptimisationErrorWarningList jobId={id} />)}
        disabled={isOptimiseRunning || !(hasErrors || hasWarnings)}
      >
        <Icon
          type="warning"
          theme={isOptimiseRunning || !(hasErrors || hasWarnings) ? 'outlined' : 'twoTone'}
          twoToneColor={hasErrors ? '#f00' : '#fa0'}
        />
        View Issues
      </Button>
    </Footer>
  </ProgressListWrapper>
);


export default OptimiseProgress;
